"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _formik = require("formik");

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _Checkbox = _interopRequireDefault(require("../Checkbox"));

var _lodash = _interopRequireDefault(require("lodash"));

var _constant = require("./constant");

var _termsAndConditions = _interopRequireDefault(require("./termsAndConditions.proptypes"));

var _excluded = ["form", "form"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var TitleContainer = _styledComponents.default.div.withConfig({
  displayName: "TermsAndConditions__TitleContainer",
  componentId: "sc-1oc2zrz-0"
})(["display:flex;justify-content:flex-start;line-height:", ";padding:", ";*:focus{outline:none;}"], function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.lineHeight.large);
}, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.space.mini, " ").concat(theme.space.none);
});

var BodyContainer = _styledComponents.default.div.withConfig({
  displayName: "TermsAndConditions__BodyContainer",
  componentId: "sc-1oc2zrz-1"
})(["display:flex;justify-content:flex-start;line-height:", ";padding:", ";*:focus{outline:none;}"], function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.lineHeight.small);
}, function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.space.mini, " ").concat(theme.space.none);
});

var MainWrapper = _styledComponents.default.div.withConfig({
  displayName: "TermsAndConditions__MainWrapper",
  componentId: "sc-1oc2zrz-2"
})(["display:flex;justify-content:space-between;flex-direction:column;font-family:", ";*:focus{outline:none;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontFamily.default;
});

var InnerWrapper = _styledComponents.default.div.withConfig({
  displayName: "TermsAndConditions__InnerWrapper",
  componentId: "sc-1oc2zrz-3"
})(["display:flex;flex-wrap:wrap;"]);

var CheckboxWrapper = _styledComponents.default.div.withConfig({
  displayName: "TermsAndConditions__CheckboxWrapper",
  componentId: "sc-1oc2zrz-4"
})(["display:flex;flex-wrap:wrap;box-sizing:border-box;"]);

CheckboxWrapper.displayName = 'CheckboxWrapper';

var StyledSpan = _styledComponents.default.span.withConfig({
  displayName: "TermsAndConditions__StyledSpan",
  componentId: "sc-1oc2zrz-5"
})(["a{color:", ";}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.darkRed;
});

var TermsAndConditions = function TermsAndConditions(props) {
  var translation = props.translation,
      theme = props.theme,
      accessible = props.accessible,
      customProperties = props.customProperties,
      titleColor = props.titleColor,
      bodyColor = props.bodyColor,
      isChina = props.isChina,
      chinaTranslation = props.chinaTranslation,
      formRef = props.formRef,
      onSubmit = props.onSubmit;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var dataExists = translation && Object.keys(translation).length !== 0;
  var isEmpty = translation && Object.values(translation).every(function (x) {
    return x === null || x === '';
  });
  var title = translation.headerTitle.replace(/&amp;/g, '&');
  var body = translation.termsText;

  var processLinks = function processLinks(htmlText, links) {
    var textWithLinks = _lodash.default.unescape(htmlText);

    if (links) {
      links.forEach(function (val, i) {
        textWithLinks = textWithLinks.replace("{".concat(i, "}"), val);
      });
    }

    return {
      __html: textWithLinks
    };
  };

  var checkboxChange = function checkboxChange(check, form, field) {
    form.errors = {};
    form.setValues(_objectSpread(_objectSpread({}, form.values), {}, (0, _defineProperty2.default)({}, field, check)));
    form.setFieldTouched(field, true, false);
  };

  var renderCheckBox = function renderCheckBox(fieldProps) {
    var form = fieldProps.form,
        values = fieldProps.form.values,
        rest = (0, _objectWithoutProperties2.default)(fieldProps, _excluded);
    var field = rest.field.name;
    return /*#__PURE__*/_react.default.createElement(_Checkbox.default, (0, _extends2.default)({}, rest, {
      disableCheckbox: false,
      isSelected: (values === null || values === void 0 ? void 0 : values[field]) === true,
      borderColor: (values === null || values === void 0 ? void 0 : values[field]) === true ? _constant.CHECKBOX_STYLE.boderColor.selected : _constant.CHECKBOX_STYLE.boderColor.unselected,
      onChange: function onChange(e) {
        checkboxChange(e, form, field);
      }
    }));
  };

  var getInitialValue = function getInitialValue() {
    var fields = {};
    /* eslint-disable-next-line react/prop-types */

    chinaTranslation.forEach(function (data, i) {
      fields["checkbox".concat(i)] = false;
    });
    return fields;
  };

  var validate = function validate(values) {
    var errors = {};

    if (!values || values.length === 0) {
      errors.required = 'Values are required';
    }

    var valuesArr = Object.entries(values);
    var hasNotSelected = valuesArr.find(function (value) {
      return value.find(function (val) {
        return val === false;
      }) === false;
    });

    if (hasNotSelected || valuesArr.length !== chinaTranslation.length) {
      errors.required = 'Values are required';
    }

    return errors;
  };

  var isChinaTnC = function isChinaTnC() {
    return /*#__PURE__*/_react.default.createElement(_formik.Formik, {
      innerRef: formRef,
      initialValues: getInitialValue,
      onSubmit: onSubmit,
      validate: validate
    }, /*#__PURE__*/_react.default.createElement(InnerWrapper, null, chinaTranslation.map(function (terms, i) {
      return /*#__PURE__*/_react.default.createElement(CheckboxWrapper, null, /*#__PURE__*/_react.default.createElement(_formik.Field, {
        theme: theme,
        component: renderCheckBox,
        text: /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
          theme: theme
        }, props), /*#__PURE__*/_react.default.createElement(StyledSpan, {
          dangerouslySetInnerHTML: processLinks(terms.termsText, terms.termsLinks)
        })),
        name: "checkbox_".concat(i)
      }));
    })));
  };

  var getMain = function getMain() {
    return translation && translation !== null && dataExists && !isEmpty ? /*#__PURE__*/_react.default.createElement(MainWrapper, (0, _extends2.default)({}, customProperties, {
      tabIndex: tabIndex
    }), isChina ? isChinaTnC() : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(TitleContainer, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: _constant.TEXT_TYPE.title.type,
      color: titleColor,
      bold: true
    }, title)), /*#__PURE__*/_react.default.createElement(BodyContainer, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: _constant.TEXT_TYPE.body.type,
      color: bodyColor,
      bold: false
    }, body)))) : null;
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

TermsAndConditions.propTypes = _termsAndConditions.default.PropTypes;
TermsAndConditions.defaultProps = _termsAndConditions.default.DefaultProps;
var _default = TermsAndConditions;
exports.default = _default;